import React, {useEffect, useState, useRef } from "react";


const FiltersDropdown = ({ activeFilters, toggleFilter, clearAllFilters, getFilterButtonText }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Закрытие при клике вне области
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="filters-dropdown-container" ref={dropdownRef}>
      <button
        className="btn btn-outline-secondary filter-btn"
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        {getFilterButtonText()}
      </button>
      
      {isOpen && (
        <div className="applications-filter-menu">
          <button
            className={`filter-item ${activeFilters.filter_selected_zdo ? 'active' : ''}`}
            onClick={() => toggleFilter('filter_selected_zdo')}
          >
            <div className="filter-checkbox">
              {activeFilters.filter_selected_zdo && <span className="filter-checkmark">✓</span>}
            </div>
            Тільки з обраними закладами
          </button>
          
          <button
            className={`filter-item ${activeFilters.filter_benefits ? 'active' : ''}`}
            onClick={() => toggleFilter('filter_benefits')}
          >
            <div className="filter-checkbox">
              {activeFilters.filter_benefits && <span className="filter-checkmark">✓</span>}
            </div>
            Тільки пільгові
          </button>
          
          <div className="dropdown-divider"></div>
          
          <button
            className="filter-clear"
            onClick={clearAllFilters}
          >
            Скинути всі фільтри
          </button>
        </div>
      )}
    </div>
  );
};

export default FiltersDropdown;